import DatePickerMode from '../../../../../../types/DatePickerMode';
import Mode from '../types/Mode';

const isMulti = (datePickerMode: DatePickerMode): boolean => {
    return (
        datePickerMode === 'PrimarilyMultiDay' ||
        datePickerMode === 'OnlyMultiDay'
    );
};

const determineMode = (
    datePickerMode: DatePickerMode,
    serverSideDatePickerMode: DatePickerMode
): Mode => {
    const localWantsMulti = isMulti(datePickerMode);
    const localWantsSingle = !localWantsMulti;

    switch (serverSideDatePickerMode) {
        case 'OnlyMultiDay':
            return {
                datePickerMode: 'OnlyMultiDay',
                allowSwitch: false,
            };

        case 'OnlySingleDay':
            return {
                datePickerMode: 'OnlySingleDay',
                allowSwitch: false,
            };

        case 'PrimarilySingleDay':
        case 'PrimarilyMultiDay':
            return {
                datePickerMode: localWantsSingle
                    ? 'OnlySingleDay'
                    : 'OnlyMultiDay',
                allowSwitch: true,
            };
    }

    return {
        datePickerMode: 'OnlyMultiDay',
        allowSwitch: true,
    };
};

export default determineMode;
